import { StandardTable } from "@/components/table/StandardTable";
import { AppColors } from "@/styles/colors";
import { Card, Flex } from "@chakra-ui/react";
import { defaultBoardHeaderElements } from "../../schema/header-elements";
import {
  DefaultPriceData,
  SuppliesData,
} from "../../schema/price-board.schema";
import { formatCurrency } from "@/utils/format-currency";
import dayjs from "dayjs";

interface Props {
  sectionData?: SuppliesData;
}

export const SuppliesPriceCard = ({ sectionData }: Props) => {
  return (
    <Card.Root
      maxW="full"
      marginTop="30px"
      borderRadius="8px"
      data-testid="supplies-price-card"
    >
      <Card.Body
        paddingX="10px"
        paddingY="12px"
        borderRadius="8px"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      >
        <Flex flexDir="column" gap="18px">
          <StandardTable
            headers={defaultBoardHeaderElements}
            items={
              sectionData?.insumos.map((el: DefaultPriceData) => ({
                ...el,
                fecha: dayjs(el?.fecha).format("DD/MM/YYYY"),
                precioSoja: `$${formatCurrency(el?.precioSoja, false)}`,
                precioMaiz: `$${formatCurrency(el?.precioMaiz, false)}`,
                precioTrigo: `$${formatCurrency(el?.precioTrigo, false)}`,
              })) ?? []
            }
            selection={[]}
            setSelection={() => null}
            noSelection
            noActions
            noBorder
          />
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};
